import React from "react";
import PropTypes from "prop-types";
import { Col } from "jsxstyle";
import { Spinner } from "@blueprintjs/core";
import CLORatingsForm from "./CLORatingsForm";
import useAsync from "hooks/useAsync";
import Modal from "components/Modal";
import loadCLORatingsService from "services/clo/loadCLORatingsService";
import loadCLOTranchePriceRatingsService from "services/clo/loadCLOTranchePriceRatingsService";

function CLORatingsFormModal({ trancheId, onData, onRequestClose, dealCode }) {
  const [
    fetchRatingAgencies,
    pendingRatingAgencies,
    dataRatingAgencies,
  ] = useAsync({
    promiseFn: loadCLORatingsService,
  });

  const [fetchTranches, pendingTranches, dataTranches] = useAsync({
    promiseFn: loadCLOTranchePriceRatingsService,
  });

  React.useEffect(() => {
    if (dealCode && trancheId) {
      fetchRatingAgencies({ dealCode: dealCode });
      fetchTranches({ dealCode: dealCode, trancheId: trancheId });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealCode, trancheId]);

  return (
    <Modal visible={trancheId} onRequestClose={onRequestClose}>
      {pendingRatingAgencies || pendingTranches ? (
        <Col
          width={600}
          minHeight={482}
          justifyContent="center"
          alignItems="center"
        >
          <Spinner />
        </Col>
      ) : (
        <CLORatingsForm
          ratingAgencies={dataRatingAgencies || []}
          tranches={dataTranches || []}
          dealCode={dealCode}
          trancheId={trancheId}
          onRequestClose={onRequestClose}
          onData={onData}
        />
      )}
    </Modal>
  );
}

CLORatingsFormModal.propTypes = {
  trancheId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dealCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  onData: PropTypes.func,
  onRequestClose: PropTypes.func,
};

CLORatingsFormModal.defaultProps = {
  onData: () => {},
  onRequestClose: () => {},
  trancheId: null,
};

export default CLORatingsFormModal;
